import React from "react"
import { Link } from "react-router-dom"
import Back from "../common/Back"
import Heading from "../common/Heading"
import FeaturedCard from "../home/featured/FeaturedCard"
import img from "../images/services.jpg"
import "./services.css"
import "../home/featured/Featured.css"

const serviceList = [
  {
    icon: <i className='fa-solid fa-magnifying-glass'></i>,
    title: "Find a Property",
    text: "Browse our listings for homes, villas, apartments, and commercial spaces. Save favourites, compare options, and get in touch with our agents when you’re ready.",
  },
  {
    icon: <i className='fa-solid fa-file-lines'></i>,
    title: "Request a Build Quote",
    text: "Have a plot or an idea? We’ll visit the site, discuss your needs, and provide a feasibility check and rough quote — no obligation.",
  },
  {
    icon: <i className='fa-solid fa-house-circle-check'></i>,
    title: "Design & Build",
    text: "Full service from concept to keys: architectural and interior design, permits, construction, and project management. We build so you don’t have to manage it.",
  },
  {
    icon: <i className='fa-solid fa-handshake'></i>,
    title: "Contract Us to Build",
    text: "Already know what you want? Contract Vista Hill Houses to build for you. We work to your specs, timeline, and budget with a dedicated project manager.",
  },
]

const Services = () => {
  return (
    <div className='services-page'>
      <section className='services mb'>
        <Back name='Services' title='What Vista Hill Houses Offers' cover={img} />
        <div className='property-types-wrap'>
            <Heading
              title='Property Types We Cover'
              subtitle='Homes, villas, apartments, offices, and more — for sale, rent, or build.'
            />
            <div className='featured container'>
              <FeaturedCard />
            </div>
          </div>
        <div className='container'>
          <div className='intro'>
            <Heading
              title='Listings & Custom Builds Under One Roof'
              subtitle='We help you find the right property or create it from scratch.'
            />
            <p>
              Vista Hill Houses is both a real estate agency and a build partner. You can search and move into an existing home, or request a custom build — from a simple consultation and quote to full design-and-build delivery. Whatever you choose, we’re here to guide you.
            </p>
          </div>

          <div className='service-cards'>
            <Heading title='How We Can Help' subtitle='Four ways to work with us' />
            <div className='cards-grid'>
              {serviceList.map((item, index) => (
                <div className='card' key={index}>
                  <div className='card-icon'>{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className='cta-section'>
            <h2>Ready to find or build your place?</h2>
            <p>Browse listings, request a build quote, or talk to our team — we’ll point you in the right direction.</p>
            <Link to='/contact'><button className='btn1'>Contact Us</button></Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Services
